/**
 * The permission codes wallet funding reads that `treasury/permissions.ts` does
 * not name yet. Kept in their own file so the route table can import them
 * without pulling the generated client into the router's bundle.
 *
 * - `treasury.wallet.funding.read` — `GET /wallet-replenishments` and
 *   `GET /treasury-wallets/{id}/funding`.
 * - `treasury.wallet.replenish` — `POST /wallet-replenishments/{id}/decide`
 *   (and the request itself).
 * - `cash.transfer.read` — following a row to its transfer instruction.
 */
export const WALLET_FUNDING_PERMISSIONS = {
  fundingRead: 'treasury.wallet.funding.read',
  replenish: 'treasury.wallet.replenish',
  transferRead: 'cash.transfer.read',
  companyRead: 'org.company.read',
  walletRead: 'treasury.wallet.read',
} as const
